import { render, staticRenderFns } from "./ServerIconIsometric.vue?vue&type=template&id=be8795cc&scoped=true"
import script from "./ServerIconIsometric.vue?vue&type=script&lang=js"
export * from "./ServerIconIsometric.vue?vue&type=script&lang=js"
import style0 from "./ServerIconIsometric.vue?vue&type=style&index=0&id=be8795cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be8795cc",
  null
  
)

export default component.exports